import {
    Box,
    Card, CardContent,
    Divider,
    Grid,
    ListItem,
    Typography
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {Warning} from "@mui/icons-material";

export function GHEFormFirstStep() {
    return (
        <>
            <Card
                elevation={0}
                sx={{
                    background: "white",
                    borderRadius: 2,
                    p: 3,
                    border: "1px solid #e0e0e0",
                }}
            >
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Instruções para preenchimento do cadastro de GHE
                </Typography>

                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                    Antes de cadastrar ou editar um Grupo Homogêneo de Exposição (GHE), siga as orientações abaixo
                    para garantir que os dados sejam registrados corretamente.
                </Typography>

                <Divider sx={{ mb: 3 }} />

                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Card variant="outlined" sx={{ borderRadius: 2, height: "100%" }}>
                            <CardContent>
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                    <BusinessOutlinedIcon color="primary" />
                                    <Typography variant="h6" fontWeight="600">
                                        Identificação do GHE
                                    </Typography>
                                </Box>
                                <List dense>
                                    <ListItem>
                                        <ListItemIcon>
                                            <ChecklistOutlinedIcon color="action" />
                                        </ListItemIcon>
                                        <ListItemText primary="Informe o nome do grupo de forma clara e objetiva." />
                                    </ListItem>
                                    <ListItem>
                                        <ListItemIcon>
                                            <ChecklistOutlinedIcon color="action" />
                                        </ListItemIcon>
                                        <ListItemText primary="Associe o grupo à empresa correta." />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Card variant="outlined" sx={{ borderRadius: 2, height: "100%" }}>
                            <CardContent>
                                <Box display="flex" alignItems="center" gap={1} mb={1}>
                                    <DescriptionOutlinedIcon color="primary" />
                                    <Typography variant="h6" fontWeight="600">
                                        Categorias e Permissões
                                    </Typography>
                                </Box>

                                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                    Cada GHE pode ter uma ou mais categorias associadas. Dentro de cada categoria, existem permissões
                                    (ou EPIs) que herdam os parâmetros definidos na categoria, podendo sobrescrevê-los quando necessário.
                                </Typography>

                                <List dense>
                                    <ListItem>
                                        <ListItemIcon>
                                            <ChecklistOutlinedIcon color="action" />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary="Selecione uma ou mais categorias para o GHE."
                                            secondary="Cada categoria representa um conjunto de EPIs com características semelhantes."
                                        />
                                    </ListItem>

                                    <ListItem>
                                        <ListItemIcon>
                                            <ChecklistOutlinedIcon color="action" />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary="Defina os parâmetros da categoria."
                                            secondary="Configure os campos de Quantidade Máxima, Período e Ponto de Alerta. Esses valores serão usados como padrão para todas as permissões dentro da categoria."
                                        />
                                    </ListItem>

                                    <ListItem>
                                        <ListItemIcon>
                                            <ChecklistOutlinedIcon color="action" />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary="Gerencie as permissões da categoria."
                                            secondary="Cada permissão herda os dados da categoria, mas pode sobrescrever os campos de Período e Ponto de Alerta ao marcar o checkbox 'Sobrescrever dados da categoria'."
                                        />
                                    </ListItem>

                                    <ListItem>
                                        <ListItemIcon>
                                            <ChecklistOutlinedIcon color="action" />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary="Ative pelo menos uma permissão."
                                            secondary="Não é permitido salvar uma categoria sem nenhuma permissão ativa. Desative apenas as que realmente não se aplicam."
                                        />
                                    </ListItem>

                                    <ListItem>
                                        <ListItemIcon>
                                            <InfoOutlinedIcon color="primary" />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary="Dica importante:"
                                            secondary="Sempre revise as informações antes de salvar. Alterações em parâmetros da categoria podem impactar todas as permissões que não estão sobrescritas."
                                        />
                                    </ListItem>

                                    <ListItem>
                                        <ListItemIcon>
                                            <Warning color="primary" />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary="Importante:"
                                            secondary="Mudanças realizadas sobre as categorias e/ou permissões só entrarão em vigor quando os parâmetros da regra atual vencerem"
                                        />
                                    </ListItem>
                                </List>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

                <Divider sx={{ my: 3 }} />

                <Box display="flex" alignItems="center" gap={1}>
                    <HelpOutlineOutlinedIcon color="primary" />
                    <Typography variant="subtitle1" fontWeight="500">
                        Dica: revise todos os campos antes de salvar para evitar inconsistências
                    </Typography>
                </Box>
            </Card>
        </>
    )
}